// Example call makeSankey({ nodes: [...], links: [...]}, 'containerID');
// There's also a jquery dependency snuck in there, now.
import d3 from "d3";
import d3Sankey from "./d3_sankey";
import generateTooltipFunctions from "./tooltips";

// the zoom/drag functionality interferes with the click to open link. Need to fix this (or disable zoom)
// import makeZoomable from "./zoomable";

const makeLink = function (d) {
  const curvature = .5;

  const xStart = d.source.x + d.source.dx;
  const xEnd = d.target.x;
  const xi = d3.interpolateNumber(xStart, xEnd);
  const xMiddle1 = xi(curvature);
  const xMiddle2 = xi(1 - curvature);

  const yStart = d.source.y; // SP edited to start/end all links at the same point
  let yMiddle1 = yStart;
  let yMiddle2 = d.target.y;
  const yEnd = d.target.y;

  const link = { xStart, yStart, xMiddle1, yMiddle1, xMiddle2, yMiddle2, xEnd, yEnd };

  const mAttr = "M" +
                link.xStart   + "," + link.yStart   +
                "C" +
                link.xMiddle1 + "," + link.yMiddle1 + " " +
                link.xMiddle2 + "," + link.yMiddle2 + " " +
                link.xEnd     + "," + link.yEnd;

  return mAttr;
};

const nodeY = -9;

const makeSankey = function (json, containerId) {
  const ourJson = json;
  const d3Container = d3.select("#" + containerId);
  return function () {
    const margin = {
      top: 50,
      right: 190,
      bottom: 50,
      left: 150
    };
    const width = 1300 - margin.left - margin.right;
    const height = +d3Container.attr("data-height-base") - margin.top - margin.bottom;
    const viewBox = "0 0 " + (width + margin.left + margin.right) + " " + (height + margin.top + margin.bottom);

    // append the svg canvas to the page
    let baseSvg = d3Container.select(".company-structure-SVG")
                             .attr("preserveAspectRatio", "xMinYMin meet")
                             .attr("viewBox", viewBox)
                             .append("g")
                             .attr("transform",
                                   "translate(" + margin.left + "," + margin.top + ")");
    // makeZoomable(baseSvg, margin);

    const svg = baseSvg;
    const graph = ourJson;

    // SI: this mutates graph.nodes adding y/dy and x/dx values that will be used below to actually layout the graph.
    d3Sankey(graph.nodes, graph.links, { width, height });

    const pathClasses = function(d) {
      const type = d.floating_associate ? "sankey-floating-associate" : d.target.type.replace("lead", "parent");
      return "link sankey-" + type;
    };

    // add in the links
    const link = svg.append("g")
                    .selectAll(".link")
                    .data(graph.links)
                    .enter().append("path")
                    .attr("class", "link")
                    .attr("d", makeLink)
                    .attr("class", pathClasses); // otherwise links from a parent to the lead entity are red.

    // add the link titles, currently not used
    link.append("title")
        .text(function () {
          return 0;
        });

    // add in the nodes
    const node = svg.append("g")
                    .selectAll(".node")
                    .data(graph.nodes);

    const tooltipFns = generateTooltipFunctions();
    // add the node groups
    const nodeEnter = node.enter()
                          .append("g")
                          .attr("class", "node")
                          .attr("transform", function (d) { return "translate(" + d.x + "," + d.y + ")"; })
                          .on("mouseover", tooltipFns.nodeGroupMouseover)
                          .on("mouseout", tooltipFns.nodeGroupMouseout);

    nodeEnter.each(function(d) {
      const thisGroup = d3.select(this);
      if (d.path) {
        const createLink = function(d) { return "/" + d.path; };
        // add links to nodes
        thisGroup.append("a")
                 .attr("xlink:href", createLink)
                 .append("text")
                 .attr("class", function(d) { return "clickable sankey-" + d.type; })
                 .attr("y", nodeY)
                 .attr("text-anchor", function(d) { return d.children || d._children ? "end" : "start"; }) // This is a neat piece of code that allows the text to be placed on the left side of the node if it has children (d.children) or on the right if it has has no children or d._children.
                 .text(function(d) { return d.name; });
        thisGroup.selectAll("a")
                 .append("circle")
                 .attr("class", function(d) { return "clickable sankey-" + d.type; })
                 .attr("r", 5); // can't set radius of circle in CSS outside of Chrome

      } else {
        thisGroup.append("text")
                 .text(function(d) { return d.name; })
                 .attr("y", nodeY)
                 .attr("text-anchor", function(d) { return d.children || d._children ? "end" : "start"; })
                 .attr("class", function(d) { return "non-clickable sankey-" + d.type; });
        thisGroup.append("circle")
                 .attr("class", function(d) { return "non-clickable sankey-" + d.type; })
                 .attr("r", 5); // can't set radius of circle in CSS outside of Chrome

      }
    });
  };
};

export default makeSankey;
